import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const key = (city) => ['shutdownInitiators', city];

const shutdownInitiatorsQuery = async (city) => {
  const data = await request.get(
    `/Alert/initiators`,
    { city },
    `При загрузке инициаторов отключения произошла ошибка`
  );

  return data;
};

export const useShutdownInitiators = (city, options) =>
  useQuery(key(city), () => shutdownInitiatorsQuery(city), options);
